export default function transformAgenceToAgenceInfo(societes) {
  const agences = [];
  societes.forEach((societe) => {
    societe.agences.forEach((agence) => {
      const agenceTransform = {
        agenceId: agence.id,
        codeAgence: agence.codeAgence,
        codeSociete: societe.codeSociete,
        libelleAgence: societes.length === 1 ? agence.libelle : agence.libelle + ' - ' + societe.libelle,
        libelleSociete: societe.libelle,
        regimeTvaId: agence.regimeTvaId,
        societeId: societe.id,
      };
      agences.push(agenceTransform);
    });
  });
  return agences;
}
